import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { SmsChatHeader, SmsChatInput, SmsChatMessages } from './chat';
import { SmsSidebar } from './sidebar';
import { SmsConversationType } from './types';

const SmsApp: React.FC = () => {
  const { t } = useTranslation('chat');
  const [selectedConversation, setSelectedConversation] =
    useState<SmsConversationType | null>(null);

  return (
    <Box display="flex" height="calc(100vh - 220px)" borderRadius={2}>
      <SmsSidebar
        selectedConversation={selectedConversation}
        onSelectConversation={setSelectedConversation}
      />
      <Box
        flex={1}
        display="flex"
        ml={4}
        flexDirection="column"
        bgcolor="#fff"
        borderRadius={2}
      >
        {selectedConversation ? (
          <>
            <SmsChatHeader conversation={selectedConversation} />
            <SmsChatMessages conversation={selectedConversation} />
            <SmsChatInput conversation={selectedConversation} />
          </>
        ) : (
          <Box
            flex={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="h6" color="text.secondary">
              {t('sms.selectConversation')}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SmsApp;
